import type {ReactElement} from 'react';
import React from 'react';
import {Icon} from '@Components/icon-v2';
import {IconShape, IconSize, IconType} from '@Components/icon-v2/icon.types';

interface StylingOptionsProps {
  icons: Array<IconStates>;

  onClick?(id?: string, icon?: string): void;
}

export interface IconStates {
  id?: string;
  icon: string;
  iconSize?: IconSize;
  iconType?: IconType;
  iconShape?: IconShape;
  isSelected?: boolean;
  isDisabled?: boolean;
  className?: string;
  onMouseEnter?(): void;
  onMouseLeave?(): void;
}

export function StylingOptions({onClick = (): void => {}, ...props}: StylingOptionsProps): ReactElement | null {
  const onClickHandler = (id: string, icon: string): void => {
    if (onClick) {
      onClick(id, icon);
    }
  };

  const getIcons = (): Array<ReactElement> => {
    return props.icons.map((obj, index) => {
      return (
        <div
          key={obj.id}
          // SelfCodeReviewAhmed: can be fixed if tooltip trigger is fixed
          onMouseEnter={(): void => {
            if (obj.onMouseEnter) {
              obj.onMouseEnter();
            }
          }}
          onMouseLeave={(): void => {
            if (obj.onMouseLeave) {
              obj.onMouseLeave();
            }
          }}
          className={index !== props.icons.length - 1 ? 'spacing-m-r-1' : ''}
        >
          <Icon
            icon={obj.icon}
            className={`${obj.className ?? ''}`}
            size={obj.iconSize ?? IconSize.SIZE_ICON_16}
            key={obj.id}
            onClick={(): void => {
              onClickHandler(obj.id ? obj.id : '', obj.icon);
            }}
            shape={obj.iconShape ?? IconShape.SQUARE}
            type={obj.iconType ?? IconType.TRANSPARENT}
            isSelected={obj.isSelected ? obj.isSelected : false}
            isDisabled={obj.isDisabled ? obj.isDisabled : false}
          />
        </div>
      );
    });
  };

  return <div className="flex-h-row flex-items-center">{getIcons()}</div>;
}
